import styled from "styled-components";
import { BoxTab, TabHeader, TabSub } from "../../../pages/YachtClubViewDetails";

interface Props {
  rejectionReason: string;
}

const BerthRentalRejection = ({ rejectionReason }: Props) => {
  return (
    <BoxTab>
      <BoxedTabEach>
        <TabHeader>Reason</TabHeader>
        <TabSub>{rejectionReason}</TabSub>
      </BoxedTabEach>
    </BoxTab>
  );
};

const BoxedTabEach = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin: 0.5rem;
  margin-left: 0;
`;

export default BerthRentalRejection;
